import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import Accepted from "../../components/Wallet/Accepted";
import Rejected from "../../components/Wallet/Rejected";
import Requested from "../../components/Wallet/Requested";
import RequestedOwner from "../../components/WalletOwner/RequestedOwner";
import AcceptedOwner from "../../components/WalletOwner/AcceptedOwner";
import RejectedOwner from "../../components/WalletOwner/RejectedOwner";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";
import FailedOwner from "../../components/WalletOwner/FailedOwner";
import WalletRejectedList from "./WalletRejectedList";
import { checkPermission } from "../redux/api/PermissionManager";
import OwnerReq from "../../components/WalletOwner/OwnerReq";

const WalletOwner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = location.pathname?.replace("/", "");

  const inputRef = useRef(null);

  // State management
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [payoutList, setIsPayoutList] = useState({
    transaction_id: "",
    remarks: "",
    fileaction: "",
    userID: "",
  });
  const [isReject, setIsReject] = useState(null);
  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [isOwnerDropdownList, setOwnerDropdownList] = useState([]);
  const [owners, setOwners] = useState([]);
  const [isfailedowners, setIsFailedOwners] = useState([]);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [activeStatus, setActiveStatus] = useState(
    paginationData?.[path]?.tab ?? 1,
  );
  const [popup, setpopup] = useState(false);
  const [isactivestatus, setIsActiveStatus] = useState();
  const [isViewIdFalied, setIsViewIdFalied] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isRejectList, setIsRejectList] = useState({
    isViewList: false,
    data: "",
    ticket_id: "",
  });
  const [filters, setFilters] = useState({
    user_id: null,
    state: null,
    city: null,
    status: { value: 1, label: "Pending" },
  });

  // Memoized function to get locations
  const getLocationsList = useCallback(async (type, parent_id) => {
    try {
      let url = `${URLS.LOCATION}?type=${type}${
        parent_id ? `&parent_id=${parent_id}` : ""
      }`;
      const res = await get(url);
      if (res?.status === "success") {
        const modifiedList = res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        if (type === 2)
          setLocationsList((prev) => ({ ...prev, states: modifiedList }));
        else if (type === 3)
          setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      toast.error("Failed to load locations");
    }
  }, []);

  // Memoized function to get owner dropdown
  const ownerDropdownListGET = useCallback(async () => {
    try {
      const url = `${URLS.OWNERS_DROPDOWN}`;
      const res = await get(url);

      if (res?.status === "success") {
        const formatted = res?.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOwnerDropdownList(formatted);
      }
    } catch (error) {
      console.error("Error fetching owners:", error);
      toast.error("Failed to load owners list");
    }
  }, []);

  // Memoized fetch function
  const fetch = useCallback(async () => {
    try {
      const payload = {
        page: page,
        search: search,
        admin_wallet_status: activeStatus || 1,
        owner_id: filters.user_id?.value,
        state_id: filters.state,
        city_id: filters.city,
      };

      // Remove empty/null values from payload
      const cleanedPayload = Object.entries(payload).reduce(
        (acc, [key, value]) => {
          if (value !== "" && value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        },
        {},
      );

      const res = await post(
        `${URLS.OWNER_WALLET_LIST}?page=${page}`,
        cleanedPayload,
      );
      console.log("res admin list", res);
      setTotalCount(res?.count || 0);

      if (!res || Object.keys(res).length === 0) {
        setOwners([]);
      } else {
        console.log("owner response success", res);
        setPagination({
          current_page: page,
          last_page: res?.next ? page + 1 : page,
        });
        setOwners(res?.data || []);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Failed to load wallet data");
      setOwners([]);
    }
  }, [
    page,
    search,
    activeStatus,
    filters.user_id,
    filters.state,
    filters.city,
  ]);

  // Memoized fetchFailed function
  const fetchFailed = useCallback(
    async (pageNum = 1, pageSize = 10) => {
      try {
        const queryParams = new URLSearchParams();
        queryParams.append("page", pageNum.toString());
        queryParams.append("pageSize", pageSize.toString());

        if (search) {
          queryParams.append("search", search);
        }

        const url = `${URLS.OWNER_WALLET_FAILED}?${queryParams.toString()}`;
        const res = await get(url);
        console.log("FINAL URL ===> ", url);

        if (res?.status === "success") {
          setTotalCount(res?.count || 0);
          setPagination({
            current_page: pageNum,
            last_page: res?.next ? pageNum + 1 : pageNum,
          });
          setOwners(res?.data || []);
        }
      } catch (err) {
        console.error("Fetch failed error:", err);
        toast.error("Failed to load failed transactions");
        setOwners([]);
      }
    },
    [search],
  );
  // Memoized fetchFailed function
  const fetchOwnerPayout = useCallback(
    async (pageNum = 1, pageSize = 10) => {
      try {
        const queryParams = new URLSearchParams();
        queryParams.append("page", pageNum.toString());
        queryParams.append("pageSize", pageSize.toString());

        if (search) {
          queryParams.append("search", search);
        }
        console.log("filters?.status", filters?.status);

        if (filters.status) {
          queryParams.append("status", filters?.status?.value);
        }
        const url = `${URLS.OWNER_PAYOUTLIST}?${queryParams.toString()}`;
        const res = await get(url);
        console.log("FINAL URL ===> ", url);

        if (res?.status === "success") {
          setTotalCount(res?.count || 0);
          setPagination({
            current_page: pageNum,
            last_page: res?.next ? pageNum + 1 : pageNum,
          });
          setOwners(res?.data || []);
        }
      } catch (err) {
        console.error("Fetch failed error:", err);
        toast.error("Failed to load failed transactions");
        setOwners([]);
      }
    },
    [search, filters.status],
  );

  // Memoized reject list view function
  const rejectListView = useCallback(
    async (pageNum = 1, pageSize = 10) => {
      try {
        const queryParams = {
          admin_transaction_id: isRejectList?.data,
          search: search,
          page: "",
          page_size: "",
        };

        const filteredParams = Object.fromEntries(
          Object.entries(queryParams).filter(([_, v]) => v != null && v !== ""),
        );

        const params = new URLSearchParams(filteredParams).toString();
        let url = `${URLS.REJECTLISTVIEW}?${params}`;
        const res = await get(url);
        console.log("SJKADKJASKDKAS", res);
        if (res?.status === "success") {
          setTotalCount(res?.count || 0);
          setPagination({
            current_page: pageNum,
            last_page: res?.next ? pageNum + 1 : pageNum,
          });
          setIsFailedOwners(res?.data || []);
        }
      } catch (error) {
        console.error("Reject list view error:", error);
        toast.error("Failed to load rejected list");
      }
    },
    [isRejectList?.data, search],
  );

  // Initialize locations and owners on mount
  useEffect(() => {
    getLocationsList(2);
    ownerDropdownListGET();
  }, [getLocationsList, ownerDropdownListGET]);

  // Main data fetch effect
  useEffect(() => {
    if (activeStatus == 5) {
      fetchOwnerPayout(page);
    } else if (activeStatus === 4) {
      fetchFailed(page);
    } else {
      fetch();
    }

    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        search: search,
        tab: activeStatus,
      },
    }));
  }, [
    activeStatus,
    page,
    search,
    fetch,
    fetchFailed,
    path,
    setpaginationData,
    filters,
  ]);

  // Reject list view effect
  useEffect(() => {
    if (isRejectList?.isViewList) {
      rejectListView();
    }
  }, [isRejectList?.isViewList, rejectListView]);

  // Handle Select All checkbox - unified function
  const handleSelectAll = useCallback(() => {
    const allSelected = owners.every((owner) => owner.selected);
    const newSelectValue = !allSelected;

    setOwners((prevOwners) =>
      prevOwners.map((owner) => ({
        ...owner,
        selected: newSelectValue,
      })),
    );
  }, [owners]);

  // Handle individual checkbox toggle
  const handleCheckboxToggle = useCallback((id) => {
    setOwners((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, selected: !item.selected } : item,
      ),
    );
  }, []);

  // Accept function
  const accept = useCallback(async () => {
    const selectedOwners = owners.filter((ele) => ele?.selected === true);

    if (selectedOwners.length === 0) {
      toast.error("Kindly choose a Wallet ID");
      return;
    }

    try {
      const payload = {
        wallet_ids: selectedOwners.map((ele) => ele?.id),
      };

      const res = await post(`${URLS.OWNER_WALLET_ACCEPT}`, payload);

      if (res.status === "success") {
        toast.success("Accepted all selected users");
        fetch();
        handleStatusChange(2);
      }
    } catch (err) {
      console.error("Accept error:", err);
      toast.error("Failed to accept transactions");
    }
  }, [owners, fetch]);

  // Reject function
  const reject = useCallback(async () => {
    const selectedOwners = owners.filter((ele) => ele?.selected === true);

    if (selectedOwners.length === 0) {
      toast.error("Kindly choose a Wallet ID");
      return;
    }

    if (!isReject) {
      toast.error("Kindly add a Reject Reason");
      return;
    }

    try {
      const payload = {
        wallet_ids: selectedOwners.map((ele) => ele?.id),
        reason: isReject,
      };

      const res = await post(`${URLS.OWNER_WALLET_REJECT}`, payload);

      if (res.status === "success") {
        toast.success("Rejected the selected users");
        fetch();
        setIsReject(null);
        setpopup(false);
        handleStatusChange(3);
      }
    } catch (err) {
      console.error("Reject error:", err);
      toast.error("Failed to reject transactions");
    }
  }, [owners, isReject, fetch]);

  // Resend function
  const reSend = useCallback(
    async ({ id }) => {
      try {
        const payload = {
          wallet_id: id,
        };

        const res = await post(`${URLS.OWNER_WALLET_RESEND}`, payload);
        console.log("ASDSADASDASDKSAKAKSDKAS", res);
        if (res.status === "success") {
          toast.success("Transaction resent successfully");
          fetch(1);
          handleStatusChange(1);
        }
      } catch (err) {
        console.error("Resend error:", err);
        toast.error("Failed to resend transaction");
      }
    },
    [fetch],
  );

  // Failed details function
  const failedDetails = useCallback(async () => {
    if (!isReject) {
      toast.error("Kindly add a Failed Reason");
      return;
    }

    if (!isViewIdFalied?.id) {
      toast.error("Invalid transaction ID");
      return;
    }

    try {
      let payload = {
        id: isViewIdFalied.id,
        description: isReject,
      };

      const res = await post(`${URLS.OWNER_WALLET_FAILED_REASON}`, payload);

      if (res.status === "success") {
        toast.success("Failed reason added successfully");
        setpopup(false);
        setIsReject(null);
        fetchFailed(page);
      }
    } catch (err) {
      console.error("Failed details error:", err);
      toast.error("Failed to add reason");
    }
  }, [isReject, isViewIdFalied, fetchFailed, page]);

  // Check if all items are selected
  const allSelected = useMemo(
    () => owners.length > 0 && owners.every((owner) => owner.selected),
    [owners],
  );

  // Handle state change
  const handleStateChange = useCallback(
    (selected) => {
      setLocationsList((prev) => ({ ...prev, cities: [] }));
      setFilters((prev) => ({
        ...prev,
        state: selected?.value || null,
        city: null,
      }));
      if (selected?.value) {
        getLocationsList(3, selected.value);
      }
      setState(selected);
      setCity(null);
      setPage(1); // Reset to first page
    },
    [getLocationsList],
  );

  // Handle city change
  const handleCityChange = useCallback((selected) => {
    setFilters((prev) => ({
      ...prev,
      city: selected?.value || null,
    }));
    setCity(selected);
    setPage(1); // Reset to first page
  }, []);

  // Handle owner change
  const handleOwnerChange = useCallback((selected) => {
    setFilters((prev) => ({ ...prev, user_id: selected }));
    setPage(1); // Reset to first page
  }, []);
  const handleOwnerPayout = useCallback((selected) => {
    console.log("selected", selected);

    setFilters((prev) => ({ ...prev, status: selected }));
    setPage(1); // Reset to first page
  }, []);

  // Handle search change
  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value);
    setPage(1); // Reset to first page on search
  }, []);

  // Handle status tab change
  const handleStatusChange = useCallback((status) => {
    setActiveStatus(status);
    setPage(1); // Reset to first page
    setIsRejectList({
      isViewList: false,
      data: "",
      ticket_id: "",
    });
  }, []);

  // Handle reject button click
  const handleRejectClick = useCallback(() => {
    const selectedItems = owners.filter((ele) => ele?.selected === true);
    if (selectedItems.length > 0) {
      setpopup(true);
    } else {
      toast.error("Kindly choose a Wallet ID");
    }
  }, [owners]);
  console.log("paginationData?.[path]?.page", paginationData?.[path]?.page);
  const handlerRepay = async (item) => {
    if (!item?.id) {
      alert("Invalid ID");
      return;
    }

    console.log("Repay ID:", item);
    try {
      let payload = {
        owner_payout_id: item?.id,
      };
      const res = await post(`${URLS.OWNER_REPAY_SEND}`, payload);
      if (res.status === "success") {
        toast.success("Repayment completed successfully");
        // setpopup(false);
        // setIsReject(null);
        fetchFailed(page);
      }
    } catch (err) {
      toast.error("Failed to add reason");
    }
  };

  const handlerPayoutListAcc = async (item) => {
    if (!payoutList.transaction_id) {
      toast.error("Transaction Id is Required");
      return;
    }
    if (!payoutList.fileaction) {
      toast.error("File Action is Required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("payout_id", isViewIdFalied.id);
      formData.append("transaction_id", payoutList.transaction_id);
      if (payoutList.remarks) {
        formData.append("remarks", payoutList.remarks); // 'remarks' maps to 'reason'
      }

      // Handle file upload for 'proof'
      if (payoutList.fileaction) {
        formData.append("proof", payoutList.fileaction); // assuming this is a File object
      }

      const res = await post(`${URLS.OWNER_PAYOUT_ACCEPT}`, formData);
      if (res.status === "success") {
        toast.success("Payout Accept completed successfully");
        setpopup(false);
        setIsReject(null);
        fetchOwnerPayout(page);
      }
    } catch (err) {
      toast.error("Failed to add reason");
    }

    console.log("PPPPPAYLOAD", isViewIdFalied.id, payoutList);
  };
  const handlerPayoutListRej = async (item) => {
    try {
      if (!isReject) {
        toast.error("Kindly add a Failed Reason");
        return;
      }

      let payload = {
        payout_id: isViewIdFalied.id,
        reason: isReject,
      };
      console.log("DAKDSDKSKDA", payload);

      const res = await post(`${URLS.OWNER_PAYOUT_FAILED}`, payload);
      if (res.status === "success") {
        toast.success("Payout Reject Successfully");
        setpopup(false);
        setIsReject(null);
        fetchOwnerPayout(page);

        // fetchFailed(page);
      }
    } catch (err) {
      toast.error("Failed to add reason");
    }
  };
  return (
    <div>
      <Topbar header={"Wallet Transaction"} subHead={"Owner"} />
      <div
        className="d-flex"
        style={{ flexDirection: "row", justifyContent: "space-between" }}
      >
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {totalCount}
        </h2>
        {checkPermission("CAN-ADD-WALLETOWNER") && activeStatus === 1 && (
          <button
            onClick={() =>
              navigate("/wallet-owner-add", {
                state: { type: "add", filter: activeStatus },
              })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
          >
            Add
          </button>
        )}
      </div>

      {isRejectList?.isViewList ? (
        <>
          <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
            <div className="d-flex gap-3">
              <button
                onClick={() => handleStatusChange(1)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 1 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Requested
              </button>

              <button
                onClick={() => handleStatusChange(2)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 2 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Accepted
              </button>

              <button
                onClick={() => handleStatusChange(3)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 3 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Rejected
              </button>
            </div>
            <div className="d-flex gap-3">
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search UserName"
                  value={search}
                  onChange={handleSearchChange}
                  style={{ border: "none", width: "150px" }}
                />
                <img src={Search_icon} className="search" alt="search" />
              </div>
            </div>
          </div>

          <WalletRejectedList
            isRejectList={isRejectList}
            ownersList={isfailedowners}
            pagination={pagination}
            page={page}
            setPage={setPage}
          />
        </>
      ) : (
        <>
          <div className="d-flex ac-jb mt-3 gap-1 ">
            <div className="d-flex gap-1">
              <button
                onClick={() => handleStatusChange(1)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 1 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Requested
              </button>

              <button
                onClick={() => handleStatusChange(2)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 2 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Accepted
              </button>

              <button
                onClick={() => handleStatusChange(3)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 3 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Rejected
              </button>

              <button
                onClick={() => handleStatusChange(4)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 4 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Failed
              </button>
              <button
                onClick={() => handleStatusChange(5)}
                className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                  activeStatus === 5 ? "active-btn1" : "inactive-btn"
                }`}
              >
                Manual Payments
              </button>
            </div>

            {activeStatus == 5 ? (
              <>
                <div
                  className="d-flex gap-1 "
                  style={{ justifyContent: "flex-end" }}
                >
                  <Select
                    className="location-search"
                    options={[
                      { value: 1, label: "Pending" },
                      { value: 2, label: "Processed" },
                      // { value: 3, label: "Failed" },
                    ]}
                    value={filters.status}
                    onChange={handleOwnerPayout}
                    // isClearable
                    // isSearchable
                    placeholder="payout status"
                    defaultValue={filters.status}
                  />

                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search UserName"
                      value={search}
                      onChange={handleSearchChange}
                      style={{ border: "none", width: "150px" }}
                    />
                    <img src={Search_icon} className="search" alt="search" />
                  </div>
                </div>
              </>
            ) : activeStatus !== 4 ? (
              <div
                className="d-flex gap-1 "
                style={{ justifyContent: "flex-end" }}
              >
                <Select
                  className="location-search"
                  options={locationList?.states}
                  value={state}
                  onChange={handleStateChange}
                  isClearable
                  placeholder="State"
                />

                <Select
                  className="location-search"
                  options={locationList?.cities}
                  value={city}
                  onChange={handleCityChange}
                  isClearable
                  placeholder="City"
                />

                <Select
                  className="location-search"
                  options={isOwnerDropdownList}
                  value={filters.user_id}
                  onChange={handleOwnerChange}
                  isClearable
                  placeholder="Owner ID"
                />

                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search UserName"
                    value={search}
                    onChange={handleSearchChange}
                    style={{ border: "none", width: "150px" }}
                  />
                  <img src={Search_icon} className="search" alt="search" />
                </div>
              </div>
            ) : (
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Search UserName"
                  value={search}
                  onChange={handleSearchChange}
                  style={{ border: "none", width: "150px" }}
                />
                <img src={Search_icon} className="search" alt="search" />
              </div>
            )}
          </div>

          {activeStatus === 1 && checkPermission("CAN-EDIT-WALLETOWNER") && (
            <div
              className="d-flex ae-je gap-3 my-3"
              style={{ alignItems: "center" }}
            >
              <input
                type="checkbox"
                style={{ width: 19, height: 22 }}
                checked={allSelected}
                onChange={handleSelectAll}
              />
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 select-btn"
                onClick={handleSelectAll}
              >
                {allSelected ? "Deselect All" : "Select All"}
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 accept-btn"
                onClick={accept}
              >
                Accept All
              </button>
              <button
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 reject-btn"
                onClick={handleRejectClick}
              >
                Reject All
              </button>
            </div>
          )}

          {activeStatus === 1 && (
            <RequestedOwner
              ownersList={owners}
              handleCheckboxToggle={handleCheckboxToggle}
              pagination={pagination}
              setPagination={setPagination}
              // deleteCoupon={deleteRoom}
              page={page}
              setPage={setPage}
            />
          )}

          {activeStatus === 2 && (
            <AcceptedOwner
              ownersList={owners}
              pagination={pagination}
              // data={transactions}
              // handleCoupon={handleCouponStatusChange}
              // loading={loading}
              // pagination={pagination}
              setPagination={setPagination}
              // deleteCoupon={deleteRoom}
              page={page}
              setPage={setPage}
              // type={type}
            />
          )}

          {activeStatus === 3 && (
            <RejectedOwner
              ownersList={owners}
              pagination={pagination}
              reSend={reSend}
              setIsUpdate={setIsUpdate}
              setIsRejectList={setIsRejectList}
              setIsViewIdFalied={setIsViewIdFalied}
              setPagination={setPagination}
              // deleteCoupon={deleteRoom}
              page={page}
              setPage={setPage}
            />
          )}

          {activeStatus === 4 && (
            <FailedOwner
              ownersList={owners}
              handleCheckboxToggle={handleCheckboxToggle}
              pagination={pagination}
              handlerPopup={setpopup}
              setIsViewIdFalied={setIsViewIdFalied}
              setPagination={setPagination}
              // deleteCoupon={deleteRoom}
              page={page}
              handlerRepay={handlerRepay}
              setPage={setPage}
            />
          )}
          {activeStatus == 5 && (
            <>
              <OwnerReq
                ownersList={owners}
                handleCheckboxToggle={handleCheckboxToggle}
                pagination={pagination}
                handlerPopup={setpopup}
                setIsViewIdFalied={setIsViewIdFalied}
                setPagination={setPagination}
                // deleteCoupon={deleteRoom}
                page={page}
                handlerRepay={handlerRepay}
                setPage={setPage}
                labels={filters.status}
                setIsActiveStatus={setIsActiveStatus}
                setIsPayoutList={setIsPayoutList}
              />
            </>
          )}
          {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                {activeStatus === 5 ? (
                  <>
                    {isactivestatus === "procced" ? (
                      <>
                        <p
                          className="f3 mt-4"
                          style={{ width: "100%", textAlign: "left" }}
                        >
                          Transaction Details
                        </p>

                        {/* <input
                          type="text"
                          className="mt-3"
                          value={payoutList.transaction_id}
                          onChange={(e) =>
                            setIsPayoutList({
                              ...payoutList,
                              transaction_id: e.target.value,
                            })
                          }
                          placeholder="Transaction ID (max-value 35)"
                          style={{
                            width: "100%",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                          
                        /> */}
                        <input
                          type="text"
                          className="mt-3"
                          value={payoutList.transaction_id}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 35) {
                              setIsPayoutList({
                                ...payoutList,
                                transaction_id: value,
                              });
                            }
                          }}
                          maxLength={35}
                          placeholder="Transaction ID (max-value 35)"
                          style={{
                            width: "100%",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />

                        <textarea
                          className="mt-3"
                          value={payoutList.remarks}
                          onChange={(e) =>
                            setIsPayoutList({
                              ...payoutList,
                              remarks: e.target.value,
                            })
                          }
                          placeholder="Remarks (max value 350)"
                          style={{
                            width: "100%",
                            textAlign: "left",
                            height: "120px",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                          maxLength={350}
                        />

                        <div className="mt-3" style={{ width: "100%" }}>
                          <input
                            id="file-upload"
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setIsPayoutList({
                                  ...payoutList,
                                  fileaction: file,
                                });
                              }
                            }}
                            style={{
                              width: "100%",
                              padding: "8px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                          {payoutList.fileaction && (
                            <p
                              style={{
                                marginTop: "8px",
                                fontSize: "14px",
                                color: "#666",
                              }}
                            >
                              Selected: {payoutList.fileaction.name}
                            </p>
                          )}
                        </div>

                        <div className="d-flex ac-jb px-2 mt-2">
                          <button
                            onClick={() => {
                              setpopup(false);
                              setIsPayoutList({
                                transaction_id: "",
                                remarks: "",
                                fileaction: "",
                              });
                            }}
                            className="reject-btn w-40"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handlerPayoutListAcc}
                            className="add-btn w-40"
                          >
                            Add
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p
                          className="f3 mt-4"
                          style={{
                            width: "100%",
                            textAlign: "left",
                            fontSize: 24,
                          }}
                        >
                          Reject Description
                        </p>
                        <textarea
                          className="mt-3"
                          value={isReject || ""}
                          onChange={(e) => setIsReject(e.target.value)}
                          placeholder="Failed Reason"
                          style={{
                            width: "100%",
                            textAlign: "left",
                            height: "120px",
                          }}
                          maxLength={300}
                        />
                        <div className="d-flex ac-jb px-2 mt-2">
                          <button
                            onClick={() => {
                              setpopup(false);
                              setIsReject(null);
                            }}
                            className="reject-btn w-40"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handlerPayoutListRej}
                            className="add-btn w-40"
                          >
                            Add
                          </button>
                        </div>
                      </>
                    )}
                  </>
                ) : activeStatus === 4 ? (
                  <>
                    <p
                      className="f3 mt-4"
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      Description
                    </p>
                    <textarea
                      className="mt-3"
                      value={isReject || ""}
                      onChange={(e) => setIsReject(e.target.value)}
                      placeholder="Failed Reason"
                      style={{
                        width: "100%",
                        textAlign: "left",
                        height: "120px",
                      }}
                    />
                    <div className="d-flex ac-jb px-2 mt-2">
                      <button
                        onClick={() => {
                          setpopup(false);
                          setIsReject(null);
                        }}
                        className="reject-btn w-40"
                      >
                        Cancel
                      </button>
                      <button onClick={failedDetails} className="add-btn w-40">
                        Add
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <h2
                      className="f4 mt-4"
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      Wallet Transaction
                    </h2>
                    <p
                      className="f3 mt-4"
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      Are you sure you want to Reject?
                    </p>
                    <textarea
                      className="mt-3"
                      value={isReject || ""}
                      onChange={(e) => setIsReject(e.target.value)}
                      placeholder="Reject Reason"
                      style={{
                        width: "100%",
                        textAlign: "left",
                        height: "120px",
                      }}
                    />
                    <div className="d-flex ac-jb px-2 mt-2">
                      <button onClick={reject} className="add-btn w-40">
                        Yes
                      </button>
                      <button
                        onClick={() => {
                          setpopup(false);
                          setIsReject(null);
                        }}
                        className="reject-btn w-40"
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WalletOwner;
